// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `wm-external-url-box .wm-box {
  position: relative;
  margin: 10px;
  border-radius: 15px;
  box-shadow: 5px 5px 5px 0px rgba(0, 0, 0, 0.1);
  transition: all 500ms;
  height: 100%;
  max-height: 176px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-content: stretch;
  align-items: stretch;
}
wm-external-url-box .wm-box wm-img {
  height: 100%;
}
wm-external-url-box .wm-box wm-img img {
  position: absolute;
  border-radius: 15px;
  object-fit: cover;
  align-self: stretch;
  height: 100%;
  width: 100%;
  filter: brightness(75%);
}
wm-external-url-box .wm-box .wm-box-title {
  font-size: 26px;
  font-family: var(--wm-font-family-content, inherit);
  font-style: normal;
  font-weight: 700;
  color: white;
  position: absolute;
  bottom: 0;
  padding: 6%;
  line-height: 31px;
  letter-spacing: 0em;
  text-align: left;
  white-space: break-spaces;
}
wm-external-url-box .wm-box .wm-box-click {
  background-color: white;
  border: none;
  color: black;
  padding: 8px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  border-radius: 30px;
  position: absolute;
  padding: 0px;
  width: 30px;
  height: 30px;
  line-height: 30px;
  bottom: 5%;
  right: 5%;
}
wm-external-url-box .wm-box .wm-box-click i {
  font-size: 12px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/wm-core/projects/wm-core/src/box/external-url-box/external-url-box.component.scss"],"names":[],"mappings":"AACE;EACE,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,8CAAA;EACA,qBAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EAEA,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,2BAAA;EACA,sBAAA;EACA,oBAAA;AADJ;AAEI;EACE,YAAA;AAAN;AACM;EACE,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,uBAAA;AACR;AAGI;EACE,eAAA;EACA,mDAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EAEA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;AAFN;AAII;EACE,uBAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,UAAA;EACA,SAAA;AAFN;AAGM;EACE,eAAA;AADR","sourcesContent":["wm-external-url-box {\n  .wm-box {\n    position: relative;\n    margin: 10px;\n    border-radius: 15px;\n    box-shadow: 5px 5px 5px 0px rgba(0, 0, 0, 0.1);\n    transition: all 500ms;\n    height: 100%;\n    max-height: 176px;\n    cursor: pointer;\n\n    display: flex;\n    flex-direction: column;\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n    align-content: stretch;\n    align-items: stretch;\n    wm-img {\n      height: 100%;\n      img {\n        position: absolute;\n        border-radius: 15px;\n        object-fit: cover;\n        align-self: stretch;\n        height: 100%;\n        width: 100%;\n        filter: brightness(75%);\n      }\n    }\n\n    .wm-box-title {\n      font-size: 26px;\n      font-family: var(--wm-font-family-content, inherit);\n      font-style: normal;\n      font-weight: 700;\n      color: white;\n      position: absolute;\n      bottom: 0;\n      padding: 6%;\n\n      line-height: 31px;\n      letter-spacing: 0em;\n      text-align: left;\n      white-space: break-spaces;\n    }\n    .wm-box-click {\n      background-color: white;\n      border: none;\n      color: black;\n      padding: 8px;\n      text-align: center;\n      text-decoration: none;\n      display: inline-block;\n      border-radius: 30px;\n      position: absolute;\n      padding: 0px;\n      width: 30px;\n      height: 30px;\n      line-height: 30px;\n      bottom: 5%;\n      right: 5%;\n      i {\n        font-size: 12px;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
